import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Register from './pages/Register';
import HomePage from './pages/HomePage';
import ChampionsLeagueLandingPage from './pages/ChampionsLeagueLandingPage';
import StartAuction from './pages/auction/StartAuction';
import JoinAuction from './pages/auction/JoinAuction';
import MyAuctions from './pages/MyAuctions';
import Account from './pages/Account';
import AllTimeRankings from './pages/AllTimeRankings';
import TrophyCabinet from './pages/TrophyCabinet';
import AuctionEnvironment from './pages/auction/AuctionEnvironment';
import RequireAuth from './components/RequireAuth';
import RequireGlobalAdmin from './components/RequireGlobalAdmin';
import AdminShell from './components/admin/AdminShell';
import AdminSeasons from './pages/admin/global/AdminSeasons';
import AdminBeheerders from './pages/admin/global/AdminBeheerders';
import AdminSeasonEnvironment from './pages/admin/global/AdminSeasonEnvironment';
import AdminSeasonDashboard from './pages/admin/global/AdminSeasonDashboard';
import AdminSubleagues from './pages/admin/global/AdminSubleagues';
import AdminStamgegevens from './pages/admin/global/AdminStamgegevens';
import AdminKalender from './pages/admin/global/AdminKalender';
import AdminRonde from './pages/admin/global/AdminRonde';
import AdminWedstrijd from './pages/admin/global/AdminWedstrijd';
import AdminPuntentelling from './pages/admin/global/AdminPuntentelling';
import AdminClubtransfers from './pages/admin/global/AdminClubtransfers';
import AdminInstellingen from './pages/admin/global/AdminInstellingen';
import AdminAutomatischeTaken from './pages/admin/global/AdminAutomatischeTaken';
import { CircularProgress, Box } from '@mui/material';
import { page } from './theme/commonStyles';

function App() {
    return (
        <AuthProvider>
            <Router>
                <Main />
            </Router>
        </AuthProvider>
    );
}

const Main = () => {
    const { loading } = useAuth();

    if (loading) {
        return (
            <Box sx={page.fullscreenLoadingContainer}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/champions-league" element={<ChampionsLeagueLandingPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            
            {/* Protected Routes */}
            <Route path="/start-auction" element={<RequireAuth><StartAuction /></RequireAuth>} />
            <Route path="/join-auction" element={<RequireAuth><JoinAuction /></RequireAuth>} />
            <Route path="/my-auctions" element={<RequireAuth><MyAuctions /></RequireAuth>} />
            <Route path="/account" element={<RequireAuth><Account /></RequireAuth>} />
            <Route path="/ranglijst-aller-tijden" element={<RequireAuth><AllTimeRankings /></RequireAuth>} />
            <Route path="/prijzenkast" element={<RequireAuth><TrophyCabinet /></RequireAuth>} />

            {/* De veiling-omgeving zelf */}
            <Route path="/auction/:auctionId/*" element={<RequireAuth><AuctionEnvironment /></RequireAuth>} />

            {/* Administrator: beheert seizoenen, stamgegevens en puntentelling van het hele spel */}
            <Route path="/admin" element={<RequireGlobalAdmin><AdminShell /></RequireGlobalAdmin>}>
                <Route index element={<AdminSeasons />} />
                <Route path="beheerders" element={<AdminBeheerders />} />
            </Route>
            <Route
                path="/admin/season/:seasonId"
                element={<RequireGlobalAdmin><AdminSeasonEnvironment /></RequireGlobalAdmin>}
            >
                <Route index element={<Navigate to="dashboard" replace />} />
                <Route path="dashboard" element={<AdminSeasonDashboard />} />
                <Route path="stamgegevens" element={<AdminStamgegevens />} />
                <Route path="kalender" element={<AdminKalender />} />
                <Route path="kalender/:roundKey" element={<AdminRonde />} />
                <Route path="kalender/:roundKey/:fixtureId" element={<AdminWedstrijd />} />
                <Route path="puntentelling" element={<AdminPuntentelling />} />
                <Route path="clubtransfers" element={<AdminClubtransfers />} />
                <Route path="automatische-taken" element={<AdminAutomatischeTaken />} />
                <Route path="instellingen" element={<AdminInstellingen />} />
                <Route path="subleagues" element={<AdminSubleagues />} />
                <Route path="*" element={<Navigate to="dashboard" replace />} />
            </Route>

            {/* Fallback voor onbekende routes */}
            <Route path="*" element={<Navigate to="/" />} />
        </Routes>
    );
};

export default App;
